import { render, staticRenderFns } from "./InvoiceRendererV2.vue?vue&type=template&id=71e4abbe&"
import script from "./InvoiceRendererV2.vue?vue&type=script&lang=js&"
export * from "./InvoiceRendererV2.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRendererV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VIcon,VThemeProvider})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e4abbe')) {
      api.createRecord('71e4abbe', component.options)
    } else {
      api.reload('71e4abbe', component.options)
    }
    module.hot.accept("./InvoiceRendererV2.vue?vue&type=template&id=71e4abbe&", function () {
      api.rerender('71e4abbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/invoiceRendererV2/InvoiceRendererV2.vue"
export default component.exports